import { Link } from 'react-router-dom';
import {
  CARD_SCHEMA_V1,
  cardFallbackText,
  cardSchemaVersion,
  formatCardDeadline,
  isSupportedCardSchema,
  normalizeDecisionCard,
} from './travelCardModel';

export default function DecisionCardMessage({ message }) {
  const card = normalizeDecisionCard(message?.decisionCard);
  if (!card) {
    return <p>{cardFallbackText(message, '此決策卡片目前無法顯示')}</p>;
  }
  if (!isSupportedCardSchema(card)) {
    return (
      <p>
        {cardFallbackText(message, '此卡片版本目前無法顯示')}
        <span className="visually-hidden"> schema {String(cardSchemaVersion(card))}</span>
      </p>
    );
  }

  const title = card.title || cardFallbackText(message, '未命名決策');
  const deadline = formatCardDeadline(card.deadlineAt);

  return (
    <article className="travel-msg-card" aria-label="決策">
      <p className="travel-msg-card__kicker">決策</p>
      <h2 className="travel-msg-card__title">{title}</h2>
      <p className="travel-msg-card__status">
        狀態：{card.decisionStatusLabel}
        {card.decisionStatus ? (
          <span className="visually-hidden"> ({card.decisionStatus})</span>
        ) : null}
      </p>
      {card.decisionTypeLabel ? <p>類型：{card.decisionTypeLabel}</p> : null}
      {deadline ? <p>截止：{deadline}</p> : null}
      {card.webRoute ? (
        <Link className="travel-msg-card__cta" to={card.webRoute}>
          查看決策
        </Link>
      ) : null}
      <span className="visually-hidden">schema {CARD_SCHEMA_V1}</span>
    </article>
  );
}
